import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RoomIcon from '@mui/icons-material/Room';
import StarIcon from '@mui/icons-material/Star';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import SecurityIcon from '@mui/icons-material/Security';
import HomeIcon from '@mui/icons-material/Home';
import StoreIcon from '@mui/icons-material/Store';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

// Curated set of icons the admin can attach to header utility items and
// nav links. Keyed by a stable string stored in the database — the actual
// MUI component is only resolved here, on the frontend, so more options
// can be added later without touching any stored data.
const iconMap = {
    "": { label: "No Icon", Icon: null },
    phone: { label: "Phone", Icon: PhoneIcon },
    email: { label: "Email", Icon: EmailIcon },
    verified: { label: "Verified / Secure", Icon: VerifiedUserIcon },
    shipping: { label: "Delivery / Shipping", Icon: LocalShippingIcon },
    room: { label: "Location", Icon: RoomIcon },
    star: { label: "Star", Icon: StarIcon },
    help: { label: "Help", Icon: HelpIcon },
    info: { label: "Info", Icon: InfoIcon },
    clock: { label: "Clock / Hours", Icon: AccessTimeIcon },
    gift: { label: "Gift", Icon: CardGiftcardIcon },
    security: { label: "Security", Icon: SecurityIcon },
    home: { label: "Home", Icon: HomeIcon },
    store: { label: "Store", Icon: StoreIcon },
    offer: { label: "Offer / Deal", Icon: LocalOfferIcon },
};

export default iconMap;
